import base from "./base.service";


const unauthorizedInstance = base.service(false);

export const contactAdmin = (request) => {
    return unauthorizedInstance.post("/Support/contact-admin", request);
};

export const becomePartner = async (request) => {
    return await unauthorizedInstance.post("/Support/become-partner", request);
};


export default {
    contactAdmin,
    becomePartner,

};